import { CssBaseline, ThemeProvider as MUIThemeProvider, ThemeOptions, createTheme } from '@mui/material'
import { FC, ReactNode, useMemo } from 'react'

import { BKBNTheme } from 'constants/styling/createBKBNTheme'
import { ThemeProvider } from '@emotion/react'

/** Provides Material theme and styles for children
 * @example
 *  <BKBNThemeWrapper>
 *    <Typography variant="h1">
 *      Hello World!
 *    </Typography>
 *  </BKBNThemeWrapper>
 */
export const BKBNThemeWrapper: FC<{
  themeOverrides?: Partial<ThemeOptions>
  children?: ReactNode
}> = ({ children, themeOverrides }) => {

  const theme = useMemo(() => createTheme({
    ...(BKBNTheme),
    ...(themeOverrides ?? {}),
  }), [themeOverrides])

  return (
    <ThemeProvider theme={theme}>
      <MUIThemeProvider theme={theme}>

        <CssBaseline />

        {children}

      </MUIThemeProvider>
    </ThemeProvider>
  )
}
